import {
  AlePayPaymentPage,
  CyberSourcePaymentPage,
  DragonPayPaymentPage,
  JpmPreparePaymentPage,
  PayByBancontact,
  PayByBankTransfer,
  PayByBlik,
  PayByFPX,
  PayByMultibanco,
  PayByWeChatPayIntent,
  PayPalPaymentPage,
  PayWithInstalments,
  RedirectMethodPage,
  SeerBitV2PaymentPage,
  SslCommerzPaymentPage,
  StatusPage,
  PayByKlarnaPage,
  AdyenPaymentPage,
  PayByCard,
  OctetPaymentPage,
  OctetV2PaymentPage,
  OctetV2PendingPage,
  PaymentSuccessPage,
  PaymentFailurePage,
  JpmPendingPaymentPage,
  PayDollarRedirectPage,
  PayDollarPendingPage,
  AdyenPendingPage,
  EsewaPendingPage,
  SeerBitV2PaymentPendingPage,
  CyberSourcePendingPage,
  AlePayPendingPage,
  DragonPayPendingPage,
  OctetPendingPage,
  PaymentPendingPage,
  AuthorizePaymentPendingPage,
  MultibancoPaymentStatus,
  PaymentExpiredPage,
  SslCommerzPendingPage,
  BankTransferPaymentData,
  PayByPrzelewy24,
  PayByUpi,
  EsewaPaymentPage,
  PayDollarPaymentPage,
  PayEasePaymentPage,
  PayByPromptPay,
  StripeQRPayment,
  FiuuPaymentPage,
  PaymobPaymentPage,
  BogPaymentPage,
  BogPendingPage,
  PaymobPendingPage,
  JpmPaymentPage,
  DokuV2PaymentPage,
  DokuV2PendingPage,
  FlutterwavePaymentPage,
  FlutterwavePendingPage,
  PaystackPaymentPage,
  PaystackPendingPage,
} from '../LazyLoadComponents';

import { commonPageOptions } from './commonOptions';
import { NppRoutes, NppSubRoute } from './routes.types';
import { FeatureFlag } from '../utils/appSettings';

const stripe: NppSubRoute[] = [
  // Payment pages
  {
    path: 'stripe/multibanco',
    element: <PayByMultibanco />,
    options: commonPageOptions.payment,
  },
  {
    path: 'stripe/multibanco/status',
    element: <MultibancoPaymentStatus />,
    options: commonPageOptions.status,
  },
  {
    path: 'stripe/banktransfer',
    element: <PayByBankTransfer />,
    options: commonPageOptions.payment,
  },
  {
    path: 'stripe/banktransfer/data',
    element: <BankTransferPaymentData />,
    options: commonPageOptions.status,
  },
  {
    path: 'stripe/bancontact',
    element: <PayByBancontact />,
    options: commonPageOptions.payment,
  },

  {
    path: 'stripe/bancontact/pending',
    element: <PaymentPendingPage paymentOption="bancontact" paymentType="intent" />,
    options: commonPageOptions.pending.timerHidden,
  },
  {
    path: 'stripe/blik',
    element: <PayByBlik />,
    options: commonPageOptions.payment,
  },
  {
    path: 'stripe/blik/pending',
    element: <AuthorizePaymentPendingPage paymentMethod="blik" timerInMinutes={1} />,
    options: {
      ...commonPageOptions.payment,
      showSidePaymentButton: false,
    },
  },
  {
    path: 'stripe/klarna',
    element: <PayByKlarnaPage />,
    options: commonPageOptions.payment,
  },
  {
    path: 'stripe/klarna/pending',
    element: <PaymentPendingPage paymentOption="klarna" paymentType="intent" />,
    options: commonPageOptions.pending.timerHidden,
  },
  {
    path: 'stripe/card',
    element: <PayByCard />,
    options: commonPageOptions.payment,
  },
  {
    path: 'stripe/fpx',
    element: <PayByFPX />,
    options: commonPageOptions.payment,
  },
  {
    path: 'stripe/fpx/pending',
    element: <PaymentPendingPage paymentOption="fpx" paymentType="intent" />,
    options: commonPageOptions.pending.timerHidden,
  },
  {
    path: 'stripe/cardinstalmentmexico',
    element: <PayWithInstalments />,
    options: commonPageOptions.payment,
  },
  {
    path: 'stripe/wechatpay',
    element: <PayByWeChatPayIntent />,
    options: {
      ...commonPageOptions.payment,
      showSidePaymentButton: false,
    },
  },
  {
    path: 'stripe/pix',
    element: <StripeQRPayment paymentMethodName="Pix" paymentOption="pix" />,
    options: {
      ...commonPageOptions.payment,
      showSidePaymentButton: false,
    },
  },
  {
    path: ['stripe/grabpay', 'stripe/alipay', 'stripe/ideal', 'stripe/paybybank', 'stripe/amazonpay', 'stripe/revolutpay'],
    element: <RedirectMethodPage submitStrategy="stripe" />,
    options: {
      ...commonPageOptions.payment,
      showSidePaymentButton: false,
    },
  },
  {
    path: 'stripe/przelewy24',
    element: <PayByPrzelewy24 />,
    options: commonPageOptions.payment,
  },
  {
    path: 'stripe/upistripe',
    element: <PayByUpi />,
    options: commonPageOptions.payment,
  },
  {
    path: 'stripe/promptpay',
    element: <PayByPromptPay />,
    options: {
      ...commonPageOptions.payment,
    },
  },
  {
    path: 'stripe/promptpay/pending',
    element: <PaymentPendingPage paymentOption="promptpay" paymentType="intent" />,
    options: commonPageOptions.pending.timerHidden,
  },
  {
    path: 'stripe/paynow',
    element: <StripeQRPayment paymentMethodName="PayNow" paymentOption="paynow" showCopyToPaySection={false} />,
    options: {
      ...commonPageOptions.payment,
      showSidePaymentButton: false
    },
  },
  {
    path: 'stripe/paynow/pending',
    element: <PaymentPendingPage paymentOption="paynow" paymentType="intent" />,
    options: commonPageOptions.pending.timerHidden,
  },
  // Pending pages
  {
    path: 'stripe/alipay/pending',
    element: <PaymentPendingPage paymentOption="alipay" paymentType="intent" />,
    options: commonPageOptions.pending.timerHidden,
  },
  {
    path: 'stripe/ideal/pending',
    element: <PaymentPendingPage paymentOption="ideal" paymentType="intent" />,
    options: commonPageOptions.pending.timerHidden,
  },
  {
    path: 'stripe/grabpay/pending',
    element: <PaymentPendingPage paymentOption="grabpay" paymentType="intent" />,
    options: commonPageOptions.pending.timerHidden,
  },
  {
    path: 'stripe/amazonpay/pending',
    element: <PaymentPendingPage paymentOption="amazonpay" paymentType="intent" />,
    options: commonPageOptions.pending.timerHidden,
  },
  {
    path: 'stripe/przelewy24/pending',
    element: <PaymentPendingPage paymentOption="przelewy24" paymentType="intent" />,
    options: commonPageOptions.pending.timerHidden,
  },
  {
    path: 'stripe/paybybank/pending',
    element: <PaymentPendingPage paymentOption="paybybank" paymentType="intent" />,
    options: commonPageOptions.pending.timerHidden,
  },
  {
    path: 'stripe/upi/pending',
    element: <AuthorizePaymentPendingPage paymentMethod="upi" timerInMinutes={5} />,
    options: {
      ...commonPageOptions.payment,
      showSidePaymentButton: false,
    },
  },
  {
    path: 'stripe/revolutpay/pending',
    element: <PaymentPendingPage paymentOption="revolutpay" paymentType="intent" />,
    options: commonPageOptions.pending.timerHidden,
  },
];

const adyen: NppSubRoute[] = [
  {
    path: 'adyen/card',
    element: <AdyenPaymentPage />,
    options: commonPageOptions.payment,
  },
  {
    path: [
      'adyen/onlinebankingindia/pay',
      'adyen/walletsindia/pay',
      'adyen/paytm/pay',
      'adyen/upi/pay',
    ],
    element: <AdyenPaymentPage />,
    options: {
      ...commonPageOptions.payment,
      showSidePaymentButton: false,
    },
  },
  {
    path: ['adyen/onlinebankingindia', 'adyen/paytm', 'adyen/walletsindia', 'adyen/upi'],
    element: <RedirectMethodPage />,
    options: {
      ...commonPageOptions.payment,
      showSidePaymentButton: false,
    },
  },

  {
    path: 'adyen/pending',
    element: <AdyenPendingPage />,
    options: commonPageOptions.pending.timerVisible,
  },
];

const payDollar: NppSubRoute[] = [
  {
    path: ['paydollar/pay', 'paydollar/paydollarcard/pay', 'paydollar/paydollarvietnam/pay'],
    element: <PayDollarPaymentPage />,
    options: { ...commonPageOptions.payment },
  },
  {
    path: 'paydollar/redirect',
    element: <PayDollarRedirectPage />,
    options: { ...commonPageOptions.payment },
  },
  {
    path: 'paydollar/pending',
    element: <PayDollarPendingPage />,
    options: commonPageOptions.pending.timerVisible,
  },
  {
    path: ['paydollar', 'paydollar/paydollarcard', 'paydollar/paydollarvietnam'],
    element: <RedirectMethodPage customDisplayName="PayDollar" />,
    options: {
      ...commonPageOptions.payment,
      showSidePaymentButton: false,
    },
  },
];

const esewa: NppSubRoute[] = [
  {
    path: 'esewa/pay',
    element: <EsewaPaymentPage />,
    options: {
      ...commonPageOptions.payment,
      showSidePaymentButton: false,
    },
  },
  {
    path: 'esewa/pending',
    element: <EsewaPendingPage />,
    options: commonPageOptions.pending.timerVisible,
  },
  {
    path: 'esewa',
    element: <RedirectMethodPage />,
    options: {
      ...commonPageOptions.payment,
      showSidePaymentButton: false,
    },
  },
];

const bankOfGeorgia: NppSubRoute[] = [
  {
    path: 'bog/pending',
    element: <BogPendingPage />,
    options: commonPageOptions.pending.timerVisible,
  },
  {
    path: 'bog/card',
    element: <BogPaymentPage />,
    options: commonPageOptions.payment,
  },
];

const dragonPay: NppSubRoute[] = [
  {
    path: 'dragonpay/syncbanktransfer',
    element: <DragonPayPaymentPage />,
    options: commonPageOptions.payment,
  },
  {
    path: 'dragonpay/pending',
    element: <DragonPayPendingPage />,
    options: { ...commonPageOptions.pending.timerVisible, customPaymentIdParam: 'param1' },
  },
];

const sslCommerz: NppSubRoute[] = [
  {
    path: ['sslcommerz/mobilebanking', 'sslcommerz/netbanking', 'sslcommerz/card'],
    element: <SslCommerzPaymentPage />,
    options: commonPageOptions.payment,
  },
  {
    path: 'sslcommerz/pending',
    element: <SslCommerzPendingPage />,
    options: commonPageOptions.pending.timerVisible,
  },
];

const jpm: NppSubRoute[] = [
  {
    path: 'jpm/card',
    element: <JpmPreparePaymentPage />,
    options: { ...commonPageOptions.payment, showSidePaymentButton: false },
  },
  {
    path: 'jpm/card/pay',
    element: <JpmPaymentPage />,
    options: { ...commonPageOptions.payment, showSidePaymentButton: false },
  },
  {
    path: 'jpm/pending',
    element: <JpmPendingPaymentPage />,
    options: commonPageOptions.pending.timerVisible,
  },
];

const seerbitV2: NppSubRoute[] = [
  {
    path: 'seerbitV2',
    element: <SeerBitV2PaymentPage />,
    options: { ...commonPageOptions.payment, showSidePaymentButton: false },
  },
  {
    path: 'seerbitV2/mobilemoney',
    element: <SeerBitV2PaymentPage />,
    options: { ...commonPageOptions.payment, showSidePaymentButton: false },
  },
  {
    path: 'seerbitV2/pending',
    element: <SeerBitV2PaymentPendingPage />,
    options: commonPageOptions.pending.timerHidden,
  },
];

const flutterwave: NppSubRoute[] = [
  {
    path: [
      'flutterwav/card',
      'flutterwav/mobilemoneyghana',
      'flutterwav/mpesa',
      'flutterwav/googlepay',
      'flutterwav/applepay',
      'flutterwav/nqr',
      'flutterwav/ussd',
      'flutterwav/mobilemoneyxof',
    ],
    element: <FlutterwavePaymentPage />,
    options: commonPageOptions.payment,
  },
  {
    path: 'flutterwav/pending',
    element: <FlutterwavePendingPage />,
    options: commonPageOptions.pending.timerVisible,
  },
];

const paystack: NppSubRoute[] = [
  {
    path: ['paystack/bankaccounts', 'paystack/mobilemoneyghana', 'paystack/card'],
    element: <PaystackPaymentPage />,
    options: commonPageOptions.payment,
  },
  {
    path: 'paystack/pending',
    element: <PaystackPendingPage />,
    options: commonPageOptions.pending.timerVisible,
  },
];

const cybersource: NppSubRoute[] = [
  {
    path: 'cybersrc/cybersource',
    element: <CyberSourcePaymentPage />,
    options: commonPageOptions.payment,
  },
  {
    path: 'cybersource/pending',
    element: <CyberSourcePendingPage />,
    options: commonPageOptions.pending.timerVisible,
  },
];

const octet: NppSubRoute[] = [
  {
    path: 'octet/card',
    element: <OctetPaymentPage />,
    options: commonPageOptions.payment,
  },
  {
    path: 'octet/pending',
    element: <OctetPendingPage />,
    options: commonPageOptions.pending.timerVisible,
  },
];

const octetV2: NppSubRoute[] = [
  {
    path: 'octetv2/card',
    element: <OctetV2PaymentPage />,
    options: commonPageOptions.payment,
  },
  {
    path: 'octetv2/pending',
    element: <OctetV2PendingPage />,
    options: commonPageOptions.pending.timerVisible,
  },
];

const doku: NppSubRoute[] = [
  {
    path: [
      'dokuv2/card',
      'dokuv2/ewallet',
      'dokuv2/qris',
      'dokuv2/jenius',
      'dokuv2/virtualaccount',
    ],
    element: <DokuV2PaymentPage />,
    options: commonPageOptions.payment,
  },
  {
    path: 'dokuv2/pending',
    element: <DokuV2PendingPage />,
    options: commonPageOptions.pending.timerVisible,
  },
];

const paypal: NppSubRoute[] = [
  {
    path: 'paypal',
    element: <PayPalPaymentPage />,
    options: { ...commonPageOptions.payment, showSidePaymentButton: false },
  },
];

const payEase: NppSubRoute[] = [
  {
    path: 'payease/alipay',
    element: <PayEasePaymentPage />,
    options: {
      ...commonPageOptions.payment,
      showSidePaymentButton: false,
    },
  },
];

const alePay: NppSubRoute[] = [
  {
    path: ['alepay/internationalcard', 'alepay/qrcode', 'alepay/vietqr', 'alepay/atmcard'],
    element: <AlePayPaymentPage />,
    options: commonPageOptions.payment,
  },
  {
    path: 'alepay/pending',
    element: <AlePayPendingPage />,
    options: commonPageOptions.pending.timerVisible,
  },
];

const fiuu: NppSubRoute[] = [
  {
    path: 'fiuu/fiuubanktransfers',
    element: <FiuuPaymentPage />,
    options: { ...commonPageOptions.payment, showSidePaymentButton: false },
  },
];

const paymob: NppSubRoute[] = [
  {
    path: 'paymob/card',
    element: <PaymobPaymentPage />,
    options: commonPageOptions.payment,
  },
  {
    path: 'paymob/pending',
    element: <PaymobPendingPage />,
    options: commonPageOptions.pending.timerVisible,
  },
];

const tpp: NppSubRoute[] = [
  {
    path: 'test',
    element: <RedirectMethodPage />,
    options: {
      ...commonPageOptions.payment,
      showSidePaymentButton: false,
    },
  },
  {
    path: 'test/card',
    element: <RedirectMethodPage />,
    options: {
      ...commonPageOptions.payment,
      showSidePaymentButton: false,
    },
  },
  {
    path: 'test/async1',
    element: <RedirectMethodPage />,
    options: {
      ...commonPageOptions.payment,
      showSidePaymentButton: false,
    },
  },
  {
    path: 'test/async2',
    element: <RedirectMethodPage />,
    options: {
      ...commonPageOptions.payment,
      showSidePaymentButton: false,
    },
  },
  {
    path: 'test/async5',
    element: <RedirectMethodPage />,
    options: {
      ...commonPageOptions.payment,
      showSidePaymentButton: false,
    },
  },
  {
    path: 'test/async21',
    element: <RedirectMethodPage />,
    options: {
      ...commonPageOptions.payment,
      showSidePaymentButton: false,
    },
  },
];

export const nppRoutes = (featureFlag: FeatureFlag): NppRoutes => {
  return {
    payment: {
      base: '/payment',
      subRoutes: [
        {
          path: '',
          element: <></>,
          options: {
            ...commonPageOptions.payment,
          },
        },
        ...stripe,
        ...adyen,
        ...payDollar,
        ...esewa,
        ...bankOfGeorgia,
        ...dragonPay,
        ...sslCommerz,
        ...jpm,
        ...seerbitV2,
        ...cybersource,
        ...octet,
        ...octetV2,
        ...doku,
        ...paypal,
        ...alePay,
        ...payEase,
        ...fiuu,
        ...paymob,
        ...flutterwave,
        ...paystack,
        ...(featureFlag?.tppEnabled ? tpp : []),
        { path: 'success', element: <PaymentSuccessPage />, options: commonPageOptions.success },
        { path: 'failure', element: <PaymentFailurePage />, options: commonPageOptions.failure },
        { path: 'expired', element: <PaymentExpiredPage />, options: commonPageOptions.failure },
        {
          path: 'status',
          element: <StatusPage />,
          options: commonPageOptions.status,
        },
      ],
    },
  };
};
